/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    instanceOfGeometryLabelDto,
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';

/**
 * @type CreateDiscreteNumericListDtoGeometry
 * 
 * @export
 */
export type CreateDiscreteNumericListDtoGeometry = GeometryLabelDto;


export function CreateDiscreteNumericListDtoGeometryFromJSON(json: any): CreateDiscreteNumericListDtoGeometry {
    return CreateDiscreteNumericListDtoGeometryFromJSONTyped(json, false);
}

export function CreateDiscreteNumericListDtoGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDiscreteNumericListDtoGeometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...GeometryLabelDtoFromJSONTyped(json, true) };
    return  GeometryLabelDtoFromJSONTyped(json, true);
}

export function CreateDiscreteNumericListDtoGeometryToJSON(value?: CreateDiscreteNumericListDtoGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfGeometryLabelDto(value)) {
        return GeometryLabelDtoToJSON(value as GeometryLabelDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateDiscreteNumericListDtoGeometry interface.
 */
export function instanceOfCreateDiscreteNumericListDtoGeometry(value: any): value is CreateDiscreteNumericListDtoGeometry {
    if (instanceOfGeometryLabelDto(value)) return true;
    return false;
}

